import {AnimatePresence} from "motion/react"
import {motion} from "motion/react"
import ReactMarkdown from "react-markdown"
import Message from "./Message"

const transition = {
 type: 'spring',
 stiffness: 200,
 mass: 0.2,
 damping: 20,
}

const variants = {
 initial: {
  opacity: 0,
  y: 300,
 },
 enter: {
  opacity: 1,
  y: 0,
  transition,
 },
}

const Messages = ({messages}) => (
  <AnimatePresence>
   {messages.map(({content, sent}) => (
     <Message
       as={motion.div}
       key={content}
       initial="initial"
       animate="enter"
       variants={variants}
       sent={sent}
       layout
     >
      <ReactMarkdown>{content}</ReactMarkdown>
     </Message>
   ))}
  </AnimatePresence>
)

export default Messages;
